import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type ProfileSelectorAvatarProps = {
  name: string;
  size?: 'sm' | 'md';
  avatarUrl?: string | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSelectorAvatar',
  props: {
    name: null,
    size: { default: 'sm' },
    avatarUrl: { default: null }
  },
  setup(__props: any) {

const props = __props as { name: string, size: 'sm' | 'md', avatarUrl: string | null };



const initials = computed(() => props.name.substring(0, 1).toLocaleUpperCase());
const imageSize = computed(() => (props.size === 'sm' ? 24 : 32));

return { __sfc: true,props, initials, imageSize }
}

})